import { Navigate, useParams } from 'react-router-dom';

import { CaseLibraryPage } from '@/pages/legacy/CaseLibraryPage';
import { LegacyArchivePage } from '@/pages/legacy/LegacyArchivePage';
import { SafeSearchPage } from '@/pages/legacy/SafeSearchPage';
import { SitePhotoTimelinePage } from '@/pages/legacy/SitePhotoTimelinePage';
import { SafeJournalPage } from '@/pages/safe/SafeJournalPage';
import { JOURNAL_TYPES } from '@/pages/safe/safeJournalApi';

import { SiteHeatStatusPage } from './heat/SiteHeatStatusPage';
import { SiteHeatZonesPage } from './heat/SiteHeatZonesPage';
import { SiteActionsPage } from './SiteActionsPage';
import { SiteHomePage } from './SiteHomePage';
import { SITE_JOURNALS, sitePath } from './siteMenu';
import { SiteTbmPage } from './SiteTbmPage';
import { SiteNearMissPage } from './voice/SiteNearMissPage';
import { SiteVoicePage } from './voice/SiteVoicePage';

export function SiteSectionPage() {
  const { siteId = '', section = '' } = useParams();
  const journal = SITE_JOURNALS.find((type) => JOURNAL_TYPES[type].path === `/${section}`);
  if (journal) return <SafeJournalPage key={`${siteId}:${journal}`} type={journal} siteId={siteId} />;
  if (section === 'home') return <SiteHomePage key={siteId} siteId={siteId} />;
  if (section === 'vendor-tbm') return <SiteTbmPage siteId={siteId} />;
  if (section === 'actions') return <SiteActionsPage siteId={siteId} />;
  if (section === 'legacy') return <LegacyArchivePage key={siteId} siteId={siteId} />;
  if (section === 'photos') return <SitePhotoTimelinePage key={siteId} siteId={siteId} />;
  if (section === 'cases') return <CaseLibraryPage key={siteId} siteId={siteId} />;
  if (section === 'search') return <SafeSearchPage key={siteId} siteId={siteId} />;
  if (section === 'near-miss') return <SiteNearMissPage key={siteId} siteId={siteId} />;
  if (section === 'voice') return <SiteVoicePage key={siteId} siteId={siteId} />;
  if (section === 'heat-status') return <SiteHeatStatusPage key={siteId} siteId={siteId} />;
  if (section === 'heat-zones') return <SiteHeatZonesPage key={siteId} siteId={siteId} />;
  return <Navigate to={sitePath(siteId)} replace />;
}
